import { Popconfirm } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

import store from 'stores/RootStore';

import FiltersToolbarButton from './FiltersToolbarButton';

function RemoveActiveFilterSetButton() {
  const store_creative = store.creative;
  const filterManager = store_creative?.ads.filter;

  const removeSet = async () => {
    if (store_creative && filterManager) {
      filterManager.saved.removeProperty(filterManager.current);
      await store_creative.save();
      filterManager.resetToScratch();
    }
  };

  // The scratch filter is not a member of `saved`, so there is nothing to
  // remove while it is current.
  const canRemove = store_creative && filterManager && !filterManager.isScratch;

  return (
    <Popconfirm
      cancelText="No"
      okText="Yes"
      onConfirm={removeSet}
      title="Delete current filter?"
    >
      <FiltersToolbarButton disabled={!canRemove} label="Remove" />
    </Popconfirm>
  );
}

export default observer(RemoveActiveFilterSetButton);
